<template>
	<div>
		<div v-if="documents != null && documents.length > 0">
			<div class="grid grid-cols-3 gap-x-8 xl:gap-x-24 gap-y-4 mt-4">
				<div v-for="document in documents" :key="document.id">
					<BaseCheckbox :disabled="!document.uuid" :label="document.label" v-model="document.isChecked" class="mb-0" />
				</div>
			</div>
		</div>
		<div v-else class="mt-4 pb-2 flex font-bold">
			{{ $t('no_documents_found') }}
		</div>
	</div>
</template>

<script>
import BaseCheckbox from '@/components/forms/inputs/BaseCheckbox';

export default {
	name: 'ProcessDocumentSentMailCardTab',
	components: { BaseCheckbox },
	props: {
		documents: { required: true },
	},
};
</script>

<style scoped></style>
